<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2021-06-14 17:38:53
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>zpush SDK</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zpush/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "2.3.0",
          linkList: [ur + "2.3.0/zpush-sdk.js", ur + "2.3.0/zpush-sdk.min.js"]
        },
        {
          label: "2.2.0",
          linkList: [ur + "2.2.0/zpush-sdk.js", ur + "2.2.0/zpush-sdk.min.js"]
        },
        {
          label: "2.1.2",
          linkList: [ur + "2.1.2/zpush-sdk.js", ur + "2.1.2/zpush-sdk.min.js"]
        },
        {
          label: "2.1.1",
          linkList: [ur + "2.1.1/zpush-sdk.js", ur + "2.1.1/zpush-sdk.min.js"]
        },
        {
          label: "2.1.0",
          linkList: [ur + "2.1.0/zpush-sdk.js", ur + "2.1.0/zpush-sdk.min.js"]
        },
        {
          label: "2.0.1",
          linkList: [ur + "2.0.1/zpush-sdk.js", ur + "2.0.1/zpush-sdk.min.js"]
        },
        {
          label: "2.0.0",
          linkList: [ur + "2.0.0/zpush-sdk.js", ur + "2.0.0/zpush-sdk.min.js"]
        },
        {
          label: "1.3.0",
          linkList: [ur + "1.3.0/zpush-sdk.js", ur + "1.3.0/zpush-sdk.min.js"]
        },
        {
          label: "1.2.0",
          linkList: [ur + "1.2.0/zpush-sdk.js", ur + "1.2.0/zpush-sdk.min.js"]
        },
        {
          label: "1.1.2",
          linkList: [ur + "1.1.2/zpush-sdk.js", ur + "1.1.2/zpush-sdk.min.js"]
        },
        {
          label: "1.1.1",
          linkList: [ur + "1.1.1/zpush-sdk.js", ur + "1.1.1/zpush-sdk.min.js"]
        },
        {
          label: "1.1.0",
          linkList: [ur + "1.1.0/zpush-sdk.js", ur + "1.1.0/zpush-sdk.min.js"]
        },
        {
          label: "1.0.4",
          linkList: [ur + "1.0.4/zpush-sdk.js", ur + "1.0.4/zpush-sdk.min.js"]
        },
        {
          label: "1.0.3",
          linkList: [ur + "1.0.3/zpush-sdk.js", ur + "1.0.3/zpush-sdk.min.js"]
        },
        {
          label: "1.0.2",
          linkList: [ur + "1.0.2/zpush-sdk.js", ur + "1.0.2/zpush-sdk.min.js"]
        },
        {
          label: "1.0.1",
          linkList: [ur + "1.0.1/zpush-sdk.js", ur + "1.0.1/zpush-sdk.min.js"]
        },
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/zpush-sdk.js", ur + "1.0.0/zpush-sdk.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZpush.vue